import actionTypes from 'constants/actionTypes'

interface ConfirmQueueItem {
  message: unknown
  action: unknown
}

interface ConfirmState {
  toConfirm: ConfirmQueueItem[]
}

interface ConfirmAction {
  type: string
  payload?: {
    idx?: number
    message?: unknown
    action?: unknown
  }
}

const initialState: ConfirmState = {
  toConfirm: []
}

export default (state: ConfirmState = initialState, action: ConfirmAction): ConfirmState => {
  switch (action.type) {
    case actionTypes.CONFIRM.CONFIRM: {
      const idx = action.payload?.idx
      if (typeof idx !== 'number') {
        return state
      }
      return {
        ...state,
        toConfirm: state.toConfirm.filter((_, currentIdx) => currentIdx !== idx),
      }
    }
    case actionTypes.CONFIRM.CANCEL: {
      const idx = action.payload?.idx
      if (typeof idx !== 'number') {
        return state
      }
      return {
        ...state,
        toConfirm: state.toConfirm.filter((_, currentIdx) => currentIdx !== idx),
      }
    }
    case actionTypes.CONFIRM.INITIATE: {
      return {
        ...state,
        toConfirm: state.toConfirm.concat({
          message: action.payload?.message,
          action: action.payload?.action,
        }),
      }
    }
  }
  return state
}
